import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function ConfidenceFlagDropdown({ onChange, defaultText }) {
  const { t } = useTranslation()
  const [showDropDown, setDropdown] = useState(false)
  const [showDefaultText, setDefaultText] = useState(
    defaultText ? defaultText : t('No Rating')
  )

  const optionsClass = ['Default', 'Low', 'Medium', 'High']
  const options = [t('No Rating'), t('Low'), t('Medium'), t('High')]
  const selectConfidenceFlag = (text) => {
    setDefaultText(text)
    setDropdown(false)
    onChange(text)
  }
  const confRef = useRef()

  //Mutable variables to maintain custom dropdown focus
  const [focusedIdx, setFocusedIdx] = useState(null)
  const [selectArr, setSelectArr] = useState([])

  React.useEffect(() => {
    window.addEventListener('click', handleClickOutsideDropdown, true)
    return () => {
      window.removeEventListener('click', handleClickOutsideDropdown, true)
    }
  }, [])

  useEffect(() => {
    if (confRef.current && showDropDown) {
      //query styled dropdown options
      setSelectArr(
        confRef.current.querySelectorAll('[tabindex]:not([tabindex="0"])')
      )
      setFocusedIdx(options.indexOf(showDefaultText))
    } else {
      setFocusedIdx(null)
    }
  }, [showDropDown])

  useEffect(() => {
    if (showDropDown && selectArr[focusedIdx]) {
      selectArr[focusedIdx].focus()
    }
  }, [focusedIdx])

  const handleClickOutsideDropdown = (e) => {
    const confidenceContainer = $('#confidenceDropdown')
    if (
      !$(confidenceContainer).is(e.target) &&
      $(confidenceContainer).has(e.target).length === 0
    ) {
      setDropdown(false)
    } else {
      confRef.current.childNodes[1].focus()
    }
  }

  const changeFocus = (idx, e) => {
    e.preventDefault()
    setFocusedIdx(idx)
  }

  const handleKeyDown = (event, data = null) => {
    //Close dropdown on escape key
    if (event.key === 'Escape' && showDropDown) {
      setDropdown(false)
      event.stopPropagation()
      event.preventDefault()
      confRef.current.childNodes[1].focus()
      return
    }
    if (event.key == 'Tab' && showDropDown) {
      setDropdown(false)
      event.preventDefault()
      confRef.current.childNodes[1].focus()
      return
    }
    if (
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'Enter'
    ) {
      if (!showDropDown) {
        setDropdown(true)
        changeFocus(focusedIdx, event)
        return
      }
    }
    switch (event.key) {
      case 'ArrowUp':
        if (!focusedIdx <= 0) setFocusedIdx(focusedIdx--)
        changeFocus(focusedIdx, event)
        break
      case 'ArrowDown':
        if (focusedIdx !== selectArr.length - 1) {
          setFocusedIdx(focusedIdx++)
        }
        changeFocus(focusedIdx, event)
        break
      case 'Enter':
        if (data) selectConfidenceFlag(data)
        confRef.current.childNodes[1].focus()
        break
      case 'Home':
        changeFocus(0, event)
        break
      case 'End':
        changeFocus(selectArr.length - 1, event)
        break
      default:
        if (/[a-zA-Z]/.test(event.key)) {
          //Navigate dropdown using the elements first letter
          for (const [index, opt] of options.entries()) {
            if (opt.charAt(0) === event.key.toUpperCase()) {
              changeFocus(index, event)
              break
            }
          }
        }
    }
  }

  return (
    <>
      <div className="confidenceFlagContainer" ref={confRef}>
        <label id="listboxlabel" role="label" data-testid="listboxlabel-testid">
        {t('Confidence')}
        </label>
        <div
          className="confidenceFlagButtonWrapper"
          onClick={() => {
            setDropdown(true)
          }}
          role="button"
          tabIndex="0"
          aria-haspopup="listbox"
          aria-labelledby="listboxlabel selected-text"
          onKeyDown={(e) => handleKeyDown(e)}
        >
          <div className="selectedValueConfidence">
            <span
              className={`confidenceIcon krDetail confidenceIcon-${
                showDefaultText != t('No Rating') ? optionsClass[options.indexOf(showDefaultText)] : 'Default'
              }`}
            ></span>
            <span id="selected-text" className="confidenceIconText">
              {showDefaultText}
            </span>
          </div>
          <div className="icon icon-dropdown-14px-2 dropdowncomp-icon"></div>
        </div>

        {showDropDown && (
          <div id="confidenceDropdown">
            <div
              className="confidenceDropdownItems"
              id="list"
              role="listbox"
              aria-labelledby="listboxlabel"
            >
              {options.map((data) => (
                <div
                  key={data}
                  role="option"
                  className="confidenceSelect confidenceDropdownItem"
                  id={`confidenceIcon-${
                    data == 'No Rating' ? 'Default' : optionsClass[options.indexOf(data)]
                  }`}
                  tabIndex="-1"
                  onClick={() => selectConfidenceFlag(data)}
                  onKeyDown={(e) => handleKeyDown(e, data)}
                >
                  <span
                    className={`confidenceIcon krDetail confidenceIcon-${
                      data == 'No Rating' ? 'Default' : optionsClass[options.indexOf(data)]
                    }`}
                  ></span>
                  <span className="confidenceIconText">{data}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
